<template>
  <div class="expande-horizontal pa-3 pl-1 pb-0 pt-0 pr-0 fonte">
    <v-flex xs12>
      <v-text-field
        v-model="filter.search"
        dense
        filled
        append-icon="mdi-magnify"
        label="Faca uma busca..."
        placeholder="telefone, polo ou responsavel"
        hide-details
        :color="$theme.primary"
        @input="$forceUpdate()"
      ></v-text-field>
    </v-flex>
    <v-flex xs12 class="mt-2">
      <v-select
        v-model="filter.purpose"
        :items="purposes"
        dense
        filled
        clearable
        item-text="label"
        item-value="value"
        label="Finalidade"
        hide-details
        :color="$theme.primary"
        @change="$forceUpdate()"
      ></v-select>
    </v-flex>
  </div>
</template>

<script>
export default {
  props: ["filter"],
  data() {
    return {
      purposes: [
        { label: "Entregas", value: "delivery" },
        { label: "Acompanhamento", value: "sale_follow_up" },
        { label: "Responsavel por orcamentos", value: "budget_owner" }
      ]
    };
  }
};
</script>
